import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../../libs/shared/ui/src/styles/paletteModel';
import {CalendarVersionModel} from '../../../../models/api/calendarVersionModel';

/*
 * Props.
 */

interface MyCalendarsDropdownProps extends DropdownProps {
  calendarVersions: ReadonlyArray<CalendarVersionModel>;
  onSelectCalendarVersion: HandlerOf<number>;
  findCalendarVersionName: (calendarVersion: CalendarVersionModel) => string;
}

/*
 * Style.
 */

const StyledTitleDiv = styled.div`
  font-size: ${fontSizes.verySmall};
  color: ${(p) => p.theme.greys.shade60};
  font-weight: ${fontWeights.semibold};

  margin: 4px 12px;
`;

interface CircleStyleProps {
  $color: PaletteColorsEnum;
}
const StyledCircleDiv = styled.div<CircleStyleProps>`
  grid-area: left-icon;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: ${(p) => p.theme.palette[p.$color].shade40};
  margin: 4px 8px 4px 0px;
`;

/*
 * Component.
 */

export const MyCalendarsDropdown: FC<MyCalendarsDropdownProps> = (props) => {
  if (props.calendarVersions.length === 0) {
    return null;
  }

  return (
    <SimpleDropdown {...props}>
      <StyledTitleDiv>
        <Trans id="scheduling-mycalendars-header">My calendars</Trans>
      </StyledTitleDiv>
      {props.calendarVersions.map((calendarVersion) => renderCalendarVersionRow(props, calendarVersion))}
    </SimpleDropdown>
  );
};

/*
 * Helpers.
 */

function renderCalendarVersionRow(props: MyCalendarsDropdownProps, calendarVersion: CalendarVersionModel) {
  return (
    <DropdownItem key={calendarVersion.id} onSelect={() => props.onSelectCalendarVersion(calendarVersion.id)}>
      <StyledCircleDiv $color={calendarVersion.color} />
      <DropdownItemContent>{props.findCalendarVersionName(calendarVersion)}</DropdownItemContent>
    </DropdownItem>
  );
}
